import { render } from "./transferOwnershipModal.vue?vue&type=template&id=c54b0710&scoped=true"
import script from "./transferOwnershipModal.vue?vue&type=script&lang=js"
export * from "./transferOwnershipModal.vue?vue&type=script&lang=js"

import "./less/transferOwnership.less?vue&type=style&index=0&id=c54b0710&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54b0710"]])

export default __exports__